
export default (state = { loading: true, list:[], org:undefined }, action) => {

  switch (action.type) {
    case 'FETCH_ORGANIZATIONS_BEGIN':
      return { ...state, loading: true };
    case 'FETCH_ORGANIZATIONS_SUCCESS':
      return { ...state, list: action.payload, loading: false };
    case 'SAVE_ORGANIZATION_SUCCESS':

      let updateExisting = state.list.filter( (org) => org.id === action.payload.id ).length > 0;

      let newList = state.list.map( (org) => org.id === action.payload.id ? action.payload : org );
      if(!updateExisting){
        newList.push(action.payload);
      }

      return { ...state,  list: newList, edit:undefined };
    case 'FILTER_ORGANIZATION':
      return { ...state,  filter:action.payload };
    case 'SHOW_EDIT_ORGANIZATION':
    return { ...state,  filter:action.payload };
    case 'EDIT_ORGANIZATION':
      return { ...state,  edit:action.payload };
    case 'CANCEL_EDIT_ORGANIZATION':
      return { ...state,  edit:undefined };
    case 'DELETE_ORGANIZATION_SUCCESS':

      let id = parseInt(action.payload.id);
      let list = state.list.filter( (org) => org.id !== id );

      return { ...state,  list, edit:undefined };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/organization/organizationReducers.js